import { ApiError } from '../api.js';

/**
 * What to tell someone whose sign-in request got no answer from Trellistry. A refusal from the edge isn't a problem
 * with their connection, and a password can trip it: it passes through the same filter as everything else.
 */
export function signInFailure(e: unknown): string {
  if (e instanceof ApiError && e.code === 'edge_refused') {
    if (e.status === 403) return 'Our security filter stopped this before it reached Trellistry. A password that looks like code can cause this, such as one containing <script> or ../. Please try again, and if it keeps happening, ask your church administrator.';
    return 'Trellistry can’t be reached just now. Please try again in a few minutes.';
  }
  return 'We couldn’t reach Trellistry. Check your connection and try again.';
}
